// extracted by mini-css-extract-plugin
export default {"specialist":"styles_specialist__o6ufx","specialistInner":"styles_specialistInner__9d8G6"};